import React, { PropsWithChildren } from "react"

import { IDragItem } from "@MODEL/uiModel"

const ClickItem: React.FC<PropsWithChildren<Partial<IDragItem>>> = (props: PropsWithChildren<Partial<IDragItem>>) => {
    return (<div onClick={() => props.dropProps?.clickHandler && props.dropProps.clickHandler(props.id)} className="clickItem NOSELECT ELLIPSIS" data-label={props.name} title={props.name}>{props.children}</div>)
}

export default ClickItem
